import script from "./SharedBoxCcList.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedBoxCcList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/share.css?vue&type=style&index=0&id=5c48d04e&scoped=true&lang=css&external"
import "./SharedBoxCcList.vue?vue&type=style&index=1&id=5c48d04e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c48d04e"]])

export default __exports__